import type { FormSubmission } from "@repo/app-types/entities/form";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { AutoLink } from "@repo/ui/Link/autoLink";
import type { FC } from "react";

interface PreInterviewFormValuesSummaryProps {
  formSubmission: FormSubmission | undefined;
}

export const PreInterviewFormValuesSummary: FC<
  PreInterviewFormValuesSummaryProps
> = ({ formSubmission }) => {
  const formValues = formSubmission?.values;

  if (!formValues?.length) {
    return null;
  }

  return (
    <div className="mt-4 mb-2">
      <Label size={Size.MEDIUM}>Pre-interview form</Label>
      <div className="mt-4 overflow-hidden border border-border-light sm:rounded-lg">
        <table className="w-full min-w-full table-fixed divide-y divide-border-light">
          <thead className="group bg-gray-50">
            <tr>
              <th
                scope="col"
                className="flex w-[50%] items-center gap-2 px-4 py-2 text-left text-xs font-medium text-muted-foreground"
              >
                Question
              </th>
              <th
                scope="col"
                className="w-[50%] px-4 py-2 text-left text-xs font-medium text-muted-foreground"
              >
                Response
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border-light bg-white">
            {formValues.map((field) => (
              <tr key={field.field_id} className={`group relative`}>
                <td className={`px-4 py-2 text-sm text-foreground`}>
                  {field.field_label}
                </td>
                <td className="px-4 py-2 text-sm text-foreground">
                  <AutoLink>{field.value?.toString()}</AutoLink>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
